import { Module } from "vuex";
import { IFlightRefundState } from "@/core/interfaces/IFlightRefunds.interface";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";

const flightRefundsModule: Module<IFlightRefundState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default flightRefundsModule;
